import { atom } from 'recoil'

export default atom({
  key: 'redirectAfterLogin',
  default: '/',
})
